export default __webpack_public_path__ + "static/img-tripletail-500x325-bbcea87392b404bb699df346da82c2d2.png";